import script from "./HomePage_Taoyuan.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePage_Taoyuan.vue?vue&type=script&setup=true&lang=js"

import "./HomePage_Taoyuan.vue?vue&type=style&index=0&id=55084c04&lang=less"

const __exports__ = script;

export default __exports__